import { stickyAd } from "../functions/others";

// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.users.show.pc").length) return;
  stickyAd("#jsAdSticky", "#jsMainFooter", 600);
});

function set_related_articles_slider() {
  $(".CarouselSlider .jsCarousel").slick({
    dots: false,
    centerMode: true,
    autoplay: true,
    variableWidth: true,
    autoplaySpeed: 3000,
    prevArrow: $(".jsSlickPrev"),
    nextArrow: $(".jsSlickNext"),
    lazyLoad: "progressive",
  });
}

// NOTE: esbuild IIFE バンドルではモジュールスコープが分離されるため、グローバルに公開する

export default set_related_articles_slider;